import * as React from 'react'
// components
import { Link, Table } from 'components/UI'
import { TableCell, TableRow } from '@mui/material'
// context
import { AccountsPageContext } from 'containers/Accounts/layers/API'
import { TableManagementContext } from 'containers/Search/layers/BL'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'

const headers = [{ id: 'account.name', sortable: false, left: true, label: 'NAME' }]

const AccountsTable: React.FC = () => {
  const { isAdmin } = useCurrentUser()

  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, totalCount, refetch, isRefetching } = React.useContext(AccountsPageContext)

  if (!isAdmin) {
    return null
  }

  return (
    <Table
      data={data}
      page={page}
      title='Accounts'
      headers={headers}
      perPage={perPage}
      refetch={refetch}
      totalCount={totalCount}
      isLoading={isRefetching}
      onPageChange={handleSetPage}
      onPerPageChange={handleSetPerPage}>
      {({ data }) =>
        data.map(({ id, name }) => (
          <TableRow key={id} hover>
            <TableCell>
              <Link href={`/settings/accounts/${id}`}>{name}</Link>
            </TableCell>
          </TableRow>
        ))
      }
    </Table>
  )
}

export default AccountsTable
